export default "__VITE_ASSET__1c1f8fd9__"